export function pushCustomerAppFlyer(customerUserId: string) {
  console.log("pushCustomerIdAppFlyer");
  window.pushCustomerIdAppFlyer(customerUserId);
}

export function pushAppFlyer(eventName: string, params: any) {
  console.log("pushAppFlyer");
  window.pushParamAppFlyer(eventName, params);
}

export function pushCustomerCleverTap(userProfile: any) {
  console.log("pushCustomerCleverTap");
  window.pushUserProfileCleverTap(userProfile);
}

export function pushCleverTapEvent(eventName: string, params: any) {
  console.log("pushCleverTapEvent");
  window.pushParamCleverTap(eventName, params);
}
